module.exports = __webpack_public_path__ + "01_very_short_black.bfcc50dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_very_short_black.png
// module id = W12Y
// module chunks = 0